import{a as t}from"./chunk-RAAYCPUM.js";function r(...n){return t(e,n)}function e(n,o){return o(n),n}export{r as a};
